import DeleteExhibit from "./DeleteExhibit";

export default DeleteExhibit